/**
 * Shared types for agent threads and CLI providers.
 *
 * These types are consumed by both the gateway (backend) and
 * the web app (frontend) for the parallel-agents UI.
 */
export const JAIT_BACKENDS = [
    "openai",
    "openrouter",
    "ollama",
    "omniroute",
    "gemini",
    "anthropic",
    "grok",
    "perplexity",
    "moonshot",
    "kimi",
    "vllm",
    "opencode-go",
];
export function isJaitBackend(value) {
    return typeof value === "string" && JAIT_BACKENDS.includes(value);
}
export function providerTypeFromId(providerId) {
    if (providerId.startsWith("codex-"))
        return "codex";
    if (providerId.startsWith("claude-code-"))
        return "claude-code";
    return providerId;
}
//# sourceMappingURL=thread.js.map